import { render, staticRenderFns } from "./PostListSkeleton.vue?vue&type=template&id=4b989f4d&lang=pug"
import script from "./PostListSkeleton.vue?vue&type=script&lang=ts"
export * from "./PostListSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports